
/**
 * Mapeamento das mensagens de erro da validacao
 */
const errorMessages = {
  tituloEmpty: 'O titulo da configuração deve ser informado',
  perguntasEmpty: 'Ao menos uma pergunta deve ser fornecida no cruzamento',
};


/**
 * Realiza a validacao de uma configuracao de cruzamento simples
 * @param {*} title titulo da configuracao
 * @param {*} crossedQuestions perguntas cruzadas
 */
export default function validateConfig(crossedQuestions) {
  let isValid = true;
  const errors = {
    isValid: true,
    // title: [],
    questions: [],
  };

  // if (!title || title.trim().length === 0) {
  //     errors.title.push(errorMessages.tituloEmpty);
  //     isValid = false;
  // }

  if (!crossedQuestions || crossedQuestions.length === 0) {
    errors.questions.push(errorMessages.perguntasEmpty);
    isValid = false;
  }

  errors.isValid = isValid;

  return errors;
}
